var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4672 6.69381L13.3234 4.83756C14.1094 4.12124 15.1411 3.73529 16.2042 3.7599C17.2672 3.78451 18.28 4.2178 19.0319 4.96972C19.7838 5.72164 20.2171 6.73438 20.2417 7.79747C20.2663 8.86057 19.8804 9.89227 19.1641 10.6782L16.5109 13.3219C16.1286 13.7057 15.6742 14.0103 15.1738 14.2181C14.6735 14.4259 14.1371 14.5328 13.5953 14.5328C13.0535 14.5328 12.5171 14.4259 12.0168 14.2181C11.5164 14.0103 11.0621 13.7057 10.6797 13.3219",
    stroke: "#FF4A01",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5335 17.3048L10.6772 19.1611C9.8913 19.8774 8.8596 20.2634 7.7965 20.2387C6.7334 20.2141 5.72067 19.7808 4.96874 19.0289C4.21682 18.277 3.78353 17.2643 3.75892 16.2012C3.73431 15.1381 4.12027 14.1064 4.83659 13.3205L7.48971 10.6767C7.87208 10.2929 8.32647 9.98837 8.8268 9.78058C9.32713 9.57279 9.86357 9.46582 10.4053 9.46582C10.9471 9.46582 11.4835 9.57279 11.9839 9.78058C12.4842 9.98837 12.9386 10.2929 13.321 10.6767",
    stroke: "#FF4A01",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLink);
export default __webpack_public_path__ + "static/media/payment-link.926d5e588ff93b539931a98f1035f78a.svg";
export { ForwardRef as ReactComponent };